import { createLucideIcon } from "lucide-react";

export const PercentageSquare = createLucideIcon(
    "PercentageSquare",
    [
        [
            "path",
            {
                d: "M10 9C10 9.5523 9.5523 10 9 10C8.4477 10 8 9.5523 8 9C8 8.4477 8.4477 8 9 8C9.5523 8 10 8.4477 10 9Z",
                key: "mi5jp1",
            },
        ],
        [
            "path",
            {
                d: "M16 14.8284C16 15.3807 15.5523 15.8284 15 15.8284C14.4477 15.8284 14 15.3807 14 14.8284C14 14.2761 14.4477 13.8284 15 13.8284C15.5523 13.8284 16 14.2761 16 14.8284Z",
                key: "fkzxur",
            },
        ],
        [
            "path",
            {
                d: "M8 16L16 8",
                key: "dmbe9n",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
